// extracted by mini-css-extract-plugin
module.exports = {"beforeStyle":"style_beforeStyle__92Yr9"};